var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_5817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 12.8187V2.33041C3.49609 2.02133 3.61887 1.72492 3.83742 1.50637C4.05597 1.28782 4.35239 1.16504 4.66146 1.16504H9.32293C9.632 1.16504 9.92842 1.28782 10.147 1.50637C10.3655 1.72492 10.4883 2.02133 10.4883 2.33041V12.8187H3.49609Z",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49626 6.99219H2.33089C2.02182 6.99219 1.7254 7.11497 1.50686 7.33352C1.28831 7.55206 1.16553 7.84848 1.16553 8.15755V11.6537C1.16553 11.9627 1.28831 12.2591 1.50686 12.4777C1.7254 12.6962 2.02182 12.819 2.33089 12.819H3.49626",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4883 5.24414H11.6536C11.9627 5.24414 12.2591 5.36692 12.4777 5.58547C12.6962 5.80402 12.819 6.10043 12.819 6.40951V11.6537C12.819 11.9627 12.6962 12.2591 12.4777 12.4777C12.2591 12.6962 11.9627 12.819 11.6536 12.819H10.4883",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82666 3.49609H8.15739",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82666 5.82715H8.15739",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82666 8.15723H8.15739",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82666 10.4883H8.15739",
    stroke: "#101828",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_5817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.cac5ea597089fe8241dbb1c8dda24473.svg";
export { ForwardRef as ReactComponent };